import * as types from 'legacy/src/constants/types';
import { flagList } from '../reducers/featureFlag';

/**
 * Set Feature Flag action. Dispatches an action that triggers an action.
 *
 * @param  {String}  flag  A feature flag constant.
 * @param  {any}     value Value to assign.
 * @return {Object}        Redux action.
 */
export default function setFeatureFlag(treatments) {
  const flags = {};

  Object.keys(treatments).forEach((key) => {
    /*
     * a fallback case for SplitFeatureFlag
     * component, where we still fetch flag one by one.
     * We send an object with a single splitName:bool treatment
     **/
    if (typeof treatments[key] === 'boolean') {
      flags[key] = treatments[key];
    }

    switch (key) {
      case 'page_footer':
        flags[key] = treatments[key] === 'show';
        break;
      case 'show_maintenance_page':
        flags[key] = treatments[key];
        break;
      case 'cb_session_expiration_threshold':
        if (Number.isNaN(parseInt(treatments[key], 10))) {
          flags[key] = 90;
        } else {
          flags[key] = parseInt(treatments[key], 10);
        }
        break;
      case 'cb_session_expiration_time':
        if (Number.isNaN(parseInt(treatments[key], 10))) {
          flags[key] = false;
        } else {
          flags[key] = parseInt(treatments[key], 10);
        }
        break;
      case 'cb_session_expiration_override':
        if (Number.isNaN(parseInt(treatments[key], 10))) {
          flags[key] = false;
        } else {
          flags[key] = parseInt(treatments[key], 10);
        }
        break;
      case 'secure_firewall_check_interval_duration_hours':
        if (Number.isNaN(parseInt(treatments[key], 10))) {
          flags[key] = 10;
        } else {
          flags[key] = parseInt(treatments[key], 10);
        }
        break;
      case 'secure_firewall_check_enable':
        flags[key] =
          treatments[key] === 'FAIL' ? flagList[key] : treatments[key] === 'on';
        break;
      case 'toast_notification_autoclose':
        if (Number.isNaN(parseInt(treatments[key], 10))) {
          flags[key] = 3000;
        } else {
          flags[key] = parseInt(treatments[key], 10);
        }
        break;
      case 'ap_qb_preview_load_more':
        if (Number.isNaN(parseInt(treatments[key], 10))) {
          flags[key] = 0;
        } else {
          flags[key] = parseInt(treatments[key], 10);
        }
        break;
      case 'my_assignment_page_size':
        if (Number.isNaN(parseInt(treatments[key], 10))) {
          flags[key] = 30;
        } else {
          flags[key] = parseInt(treatments[key], 10);
        }
        break;
      case 'qb_cached_lrn_questions_limit':
        if (Number.isNaN(parseInt(treatments[key], 10))) {
          flags[key] = 30;
        } else {
          flags[key] = parseInt(treatments[key], 10);
        }
        break;
      case 'assignments_overview_info_panel':
        flags[key] =
          treatments[key] === 'both'
            ? treatments[key]
            : treatments[key] === 'on';
        break;
      case 'enter_scores_expansion':
        if (treatments[key] === 'on') {
          flags[key] = true;
        } else if (treatments[key] === 'off') {
          flags[key] = false;
        } else if (treatments[key] === 'print_only') {
          flags[key] = 'print_only';
        }
        break;
      default:
        flags[key] = treatments[key] === 'on';
    }

    /*
     * a fallback case for SplitFeatureFlag
     * component in case we get treatment with config which would
     * mean that treatments would be
     * { treatment: "on", config: {'some-key': 'some-value', ...} }
     **/
    if (typeof treatments[key] === 'object') {
      const flagValue = {
        ...treatments[key],
        treatment: treatments[key]?.treatment === 'on',
      };
      flags[key] = flagValue;
    }
  });

  return { type: types.SET_FEATURE_FLAG, payload: { flags } };
}
